import { IconBase, IconComponent } from './BaseIcon';

export const FullscreenOff: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="m27 2.8-7.8 7.7V6.4H16V16h9.7v-3.2h-4.2L29.3 5ZM6.4 16v3.2h4.1L2.7 27 5 29.2l7.8-7.8v4.2H16V16Z" />
  </IconBase>
);
